/**
 * BillingErrorState - Error state component with retry functionality.
 */

import { Alert, Button, Text } from "@mantine/core";
import { IconAlertCircle, IconRefresh } from "@tabler/icons-react";

interface BillingErrorStateProps {
  errorMessage: string;
  onRetry: () => void;
  isRetrying: boolean;
}

export const BillingErrorState = ({
  errorMessage,
  onRetry,
  isRetrying,
}: BillingErrorStateProps) => {
  return (
    <Alert
      icon={<IconAlertCircle size={16} />}
      title="Unable to load billing information"
      color="red"
      variant="light"
      maw={1000}
    >
      <Text size="sm" mb="md">
        {errorMessage}
      </Text>
      <Button
        variant="light"
        color="red"
        size="sm"
        leftSection={<IconRefresh size={16} />}
        onClick={onRetry}
        loading={isRetrying}
      >
        Try Again
      </Button>
    </Alert>
  );
};
